import { initializeApp } from "firebase/app";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./style.css";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDwACAlg9GFHMYwk2h8FhwaCmEh8wT36bs",
  authDomain: "resume-f71f6.firebaseapp.com",
  projectId: "resume-f71f6",
  storageBucket: "resume-f71f6.firebasestorage.app",
  messagingSenderId: "942337378901",
  appId: "1:942337378901:web:ad6b8656cd1a5d5ca9a2dc",
  measurementId: "G-BL7HNLPEH8",
};

// Initialize Firebase
initializeApp(firebaseConfig);

// Mount React app
const root = document.getElementById("root");
if (root) {
  createRoot(root).render(<App />);
}
